import { useEnergyDrawerContext } from '../../context/PlpContext';
import { dispatchCitrusAnalytics } from '../analytics/analyticsEvents';

export const useEnergyDrawerData = () => {
  const {
    energyDrawerData,
    energyDrawerIsOpen,
    setEnergyDrawerData,
    setEnergyDrawerIsOpen,
  } = useEnergyDrawerContext();

  const openEnergyDrawer = (
    altText: string,
    energyRating: string,
    energyLabel: string,
    energyInformationSheet: string,
    adId: string,
    productId: string
  ) => {
    setEnergyDrawerData({
      imageSrc: energyLabel,
      altText,
      energyRating,
      energyInformationSheet,
    });
    setEnergyDrawerIsOpen(true);
    if (adId) {
      dispatchCitrusAnalytics(productId, adId);
    }
  };

  const closeEnergyDrawer = () => {
    setEnergyDrawerIsOpen(false);
  };

  return {
    energyDrawerData: energyDrawerData,
    isOpen: energyDrawerIsOpen,
    openEnergyDrawer,
    closeEnergyDrawer,
  };
};
